export const TwitterSvg = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M22.749 1.552L22.1978 3.5301C22.1233 3.79734 22.0369 4.05441 21.9485 4.29109L23.9215 3.28227L22.6494 5.48247C22.15 6.34613 21.5279 7.12177 20.8084 7.76795L20.8137 8.00449V8.0129C20.8137 11.1356 19.7877 14.4977 17.8039 17.0948C15.808 19.7078 12.8274 21.5589 8.97452 21.5589C6.59861 21.5589 4.39629 20.7533 2.55362 19.3879L0.233398 17.6688L3.09697 18.0416C3.37259 18.0775 3.65006 18.097 3.92976 18.097C4.99587 18.097 6.01165 17.8228 6.926 17.3245C5.57906 16.8311 4.32695 15.8235 3.46837 14.3374L2.60648 12.8455L4.28546 13.2312C4.27161 13.228 4.27199 13.228 4.2923 13.2292C4.30838 13.2302 4.33696 13.2319 4.38086 13.2335C4.14582 13.0341 3.92227 12.8158 3.71485 12.5807C2.86806 11.6212 2.25013 10.3374 2.25013 8.85967V6.79286L3.41606 8.13825C3.17722 7.50318 3.04676 6.80723 3.04676 6.08252C3.04676 5.14198 3.26474 4.25295 3.65491 3.48297L4.21785 2.37201L4.93648 3.38923C6.56412 5.69316 8.89074 7.25794 11.5087 7.6757C11.507 7.61611 11.5061 7.55633 11.5061 7.49639C11.5061 4.70394 13.4901 2.24999 16.1539 2.24999C17.3583 2.24999 18.4391 2.76326 19.2493 3.57879C19.8866 3.38591 20.4917 3.09188 21.0527 2.70922L22.749 1.552ZM4.02089 10.2667C4.21252 10.7536 4.49606 11.199 4.83953 11.5882C5.49907 12.3356 6.33952 12.8293 7.06044 12.9967L9.7567 13.6227L7.11322 14.4435C7.09367 14.4496 7.07297 14.456 7.05122 14.4629C6.75275 14.5564 6.25563 14.7122 5.79425 14.7122C5.75462 14.7122 5.69384 14.7136 5.61628 14.7157C6.5516 15.6771 7.71664 16.1527 8.78598 16.175L10.6741 16.2145L9.27332 17.4811C8.23298 18.4219 6.98935 19.0977 5.62458 19.4074C6.67719 19.8302 7.8037 20.0589 8.97452 20.0589C12.2916 20.0589 14.8556 18.4836 16.6118 16.1843C18.3784 13.8715 19.3119 10.8393 19.3137 8.0212L19.2926 7.08315L19.574 6.85156C19.8845 6.59607 20.1774 6.31006 20.4494 5.99756L19.5698 5.74106L20.0244 4.92083L20.0276 4.91496L20.0364 4.89853C19.7525 4.99942 19.462 5.08421 19.1656 5.15189L18.7107 5.25574L18.4165 4.8936C17.8282 4.16944 17.0208 3.74999 16.1539 3.74999C14.5127 3.74999 13.0061 5.32389 13.0061 7.49639C13.0061 7.79975 13.0358 8.09378 13.0921 8.37251L13.285 9.32622L12.3136 9.26992C9.2928 9.09484 6.5924 7.63009 4.60179 5.38021C4.56572 5.60699 4.54676 5.84171 4.54676 6.08252C4.54676 7.42752 5.14064 8.57801 5.98814 9.23143L7.84803 10.6654L5.50129 10.5748C5.10071 10.5594 4.54884 10.4506 4.02089 10.2667ZM20.6807 5.28378L20.4843 5.95713C20.4845 5.95697 20.4842 5.95729 20.4843 5.95713C20.5045 5.88722 20.5554 5.71343 20.6807 5.28378Z" fill="white"/>
</svg>
`;

export const FacebookSvg = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6 1.25C3.37665 1.25 1.25 3.37665 1.25 6V18C1.25 20.6234 3.37665 22.75 6 22.75H18C20.6234 22.75 22.75 20.6234 22.75 18V6C22.75 3.37665 20.6234 1.25 18 1.25H6ZM2.75 6C2.75 4.20507 4.20507 2.75 6 2.75H18C19.7949 2.75 21.25 4.20507 21.25 6V18C21.25 19.7949 19.7949 21.25 18 21.25H13.1931V14.4535H15.5508L15.9046 11.7141H13.1931V9.96543C13.1931 9.17257 13.4124 8.63224 14.5506 8.63224L16 8.63165V6.18147C15.7494 6.1489 14.889 6.07422 13.8876 6.07422C11.7965 6.07422 10.3649 7.3506 10.3649 9.69412V11.7141H8V14.4535H10.3649V21.25H6C4.20507 21.25 2.75 19.7949 2.75 18V6Z" fill="white"/>
</svg>
`;

export const InstagramSvg = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.25 6C1.25 3.37665 3.37665 1.25 6 1.25H18C20.6234 1.25 22.75 3.37665 22.75 6V18C22.75 20.6234 20.6234 22.75 18 22.75H6C3.37665 22.75 1.25 20.6234 1.25 18V6ZM6 2.75C4.20507 2.75 2.75 4.20507 2.75 6V18C2.75 19.7949 4.20507 21.25 6 21.25H18C19.7949 21.25 21.25 19.7949 21.25 18V6C21.25 4.20507 19.7949 2.75 18 2.75H6ZM12 7.75C9.65279 7.75 7.75 9.65279 7.75 12C7.75 14.3472 9.65279 16.25 12 16.25C14.3472 16.25 16.25 14.3472 16.25 12C16.25 9.65279 14.3472 7.75 12 7.75ZM6.25 12C6.25 8.82436 8.82436 6.25 12 6.25C15.1756 6.25 17.75 8.82436 17.75 12C17.75 15.1756 15.1756 17.75 12 17.75C8.82436 17.75 6.25 15.1756 6.25 12ZM18.5 7C19.3284 7 20 6.32843 20 5.5C20 4.67157 19.3284 4 18.5 4C17.6716 4 17 4.67157 17 5.5C17 6.32843 17.6716 7 18.5 7Z" fill="white"/>
</svg>
`;

export const YoutubeSvg = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.12626 6.04674C5.97119 5.92349 9.08736 5.75 12 5.75C14.9126 5.75 18.0288 5.92349 19.8737 6.04674C20.4614 6.08601 20.9261 6.54031 20.9781 7.12446C21.1019 8.51248 21.25 10.4927 21.25 12C21.25 13.507 21.1021 15.5645 20.9782 17.0186C20.9264 17.6276 20.4282 18.0989 19.8099 18.1175C17.9512 18.1734 14.8785 18.25 12 18.25C9.12145 18.25 6.04877 18.1734 4.19006 18.1175C3.57177 18.0989 3.07362 17.6276 3.02177 17.0186C2.89795 15.5645 2.75 13.507 2.75 12C2.75 10.4927 2.89809 8.51248 3.02186 7.12446C3.07395 6.54031 3.53858 6.08601 4.12626 6.04674ZM12 4.25C9.03784 4.25 5.88306 4.42603 4.02627 4.55008C2.7041 4.63841 1.64571 5.66884 1.52779 6.99123C1.40359 8.38401 1.25 10.421 1.25 12C1.25 13.5764 1.40316 15.6894 1.52718 17.1459C1.64429 18.5213 2.7726 19.5755 4.14495 19.6168C6.00918 19.6729 9.09922 19.75 12 19.75C14.9008 19.75 17.9908 19.6729 19.8551 19.6168C21.2274 19.5755 22.3557 18.5213 22.4728 17.1459C22.5968 15.6894 22.75 13.5764 22.75 12C22.75 10.421 22.5964 8.38401 22.4722 6.99123C22.3543 5.66884 21.2959 4.63841 19.9737 4.55008C18.1169 4.42603 14.9622 4.25 12 4.25ZM15 12L10 9V15L15 12Z" fill="white"/>
</svg>
`;

export const GiphySvg = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6 2H4V22H6H20V20V10H18V20H6V4H14V8H18H20V6H18V4H16V2H6Z" fill="white"/>
</svg>
`;

export const loadingSvg = `
<?xml version="1.0" encoding="UTF-8" standalone="no"?><svg
  xmlns:svg="http://www.w3.org/2000/svg"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  version="1.0"
  width="64px"
  height="64px"
  viewBox="0 0 128 128"
  xml:space="preserve"
>
  <g>
    <path d="M59.6 0h8v40h-8V0z" fill="#000000" fill-opacity="1" />
    <path
      d="M59.6 0h8v40h-8V0z"
      fill="#cccccc"
      fill-opacity="0.2"
      transform="rotate(30 64 64)"
    />
    <path
      d="M59.6 0h8v40h-8V0z"
      fill="#cccccc"
      fill-opacity="0.2"
      transform="rotate(60 64 64)"
    />
    <path
      d="M59.6 0h8v40h-8V0z"
      fill="#cccccc"
      fill-opacity="0.2"
      transform="rotate(90 64 64)"
    />
    <path
      d="M59.6 0h8v40h-8V0z"
      fill="#cccccc"
      fill-opacity="0.2"
      transform="rotate(120 64 64)"
    />
    <path
      d="M59.6 0h8v40h-8V0z"
      fill="#b2b2b2"
      fill-opacity="0.3"
      transform="rotate(150 64 64)"
    />
    <path
      d="M59.6 0h8v40h-8V0z"
      fill="#999999"
      fill-opacity="0.4"
      transform="rotate(180 64 64)"
    />
    <path
      d="M59.6 0h8v40h-8V0z"
      fill="#7f7f7f"
      fill-opacity="0.5"
      transform="rotate(210 64 64)"
    />
    <path
      d="M59.6 0h8v40h-8V0z"
      fill="#666666"
      fill-opacity="0.6"
      transform="rotate(240 64 64)"
    />
    <path
      d="M59.6 0h8v40h-8V0z"
      fill="#4c4c4c"
      fill-opacity="0.7"
      transform="rotate(270 64 64)"
    />
    <path
      d="M59.6 0h8v40h-8V0z"
      fill="#333333"
      fill-opacity="0.8"
      transform="rotate(300 64 64)"
    />
    <path
      d="M59.6 0h8v40h-8V0z"
      fill="#191919"
      fill-opacity="0.9"
      transform="rotate(330 64 64)"
    />
    <animateTransform
      attributeName="transform"
      type="rotate"
      values="0 64 64;30 64 64;60 64 64;90 64 64;120 64 64;150 64 64;180 64 64;210 64 64;240 64 64;270 64 64;300 64 64;330 64 64"
      calcMode="discrete"
      dur="1080ms"
      repeatCount="indefinite"
    ></animateTransform>
  </g>
</svg>
`;
